interface IStoreLoader {
  classnames: string;
}

export default function StoreLoader({ classnames }: IStoreLoader) {
  return <div className={classnames} />;
}
